<template>
  <div class="space">
    <div class="center">
      <div class="center-top">
        <div class="return" @click="repage"><img src="@/assets/images/return.png" alt="">返回上一步</div>
        <div class="step">
          <div :class="step == 0 ? 'item itemed' : 'item'">剧本创意</div>
          <div class="jt"><img v-show="step == 0" src="@/assets/images/jtl.png" alt=""><img v-show="step != 0"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 1 ? 'item itemed' : 'item'">剧情梗概</div>
          <div class="jt"><img v-show="step == 1" src="@/assets/images/jtl.png" alt=""><img v-show="step != 1"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 2 ? 'item itemed' : 'item'">分段脚本</div>
          <div class="jt"><img v-show="step == 2" src="@/assets/images/jtl.png" alt=""><img v-show="step != 2"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 3 ? 'item itemed' : 'item'">角色设计</div>
          <div class="jt"><img v-show="step == 3" src="@/assets/images/jtl.png" alt=""><img v-show="step != 3"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 4 ? 'item itemed' : 'item'">生成分镜</div>
        </div>
      </div>
      <div class="center-body">
        <div class="stepbox step3">
          <div class="l custom-scrollbar">
            <div class="loading" v-if="loading">
              <el-skeleton :rows="8" animated />
              <el-skeleton :rows="8" animated style="margin-top: 40px;" />
              <div class="l1"><a-spin size="large" />
                <div class="js">正在生成分段详情..，约耗时45秒左右，请勿离开页面</div>
              </div>

            </div>
            <div class="loaded" v-else>
              <div class="jb_top">
                <div class="jb_l">{{ title }}</div>
                <div class="jb_r"></div>
              </div>
              <div class="jb_center"></div>
              <div class="item item_top">
                <div class="item_left">
                  <div class="line"></div>
                </div>
                <div class="item_right">
                  <div class="item_r1" style="font-size: 20px;font-weight:600">
                    画面
                  </div>
                  <div class="item_r2" style="font-size: 20px;font-weight:600">
                    解说词
                  </div>
                  <div class="item_r3" style="font-size: 20px;font-weight:600">音效/音乐</div>

                </div>
              </div>
              <div class="itembox custom-scrollbar" :style="draggingIndex != -1 ? 'cursor: move;' : ''">
                <!-- 关键：用 transition-group 包裹列表，实现列表项过渡 -->
                <transition-group name="list-swap" tag="div" class="drag-list-wrapper">
                  <div class="item" v-for="(item, index) in part" :style="draggingIndex == index ? 'opacity:0.5;' : ''"
                    :key="index">
                    <div class="item_left">
                      <div class="line"></div>
                      <div class="part">Part{{ index + 1 }}</div>
                      <div class="duration"><input type="text" v-model="part2[index].duration"><span>{{ part2[index].duration }}s</span>
                      </div>
                      <div class="td" @mousedown.stop="startDrag(index)"><img src="@/assets/images/td.png" alt="">拖动
                      </div>
                    </div>
                    <div class="item_right">
                      <div class="item_r1">
                        <div class="refresh" v-if="zdrefresh==index">
                          <el-skeleton :rows="4" animated />
                        </div>
                        <div v-else>
                          <div class="it1">
                            <div class="aiChange" v-show="aishow==index">
                              <span><img src="@/assets/images/aichange2.png" alt=""> AI修改</span>
                              <textarea v-model="part2[index].aiChange" class="custom-scrollbar" name="" id=""></textarea>
                              <i @click="aiChange(index)">→</i>
                            </div>
                          <div class="left"><input type="text" v-model="part2[index].title">
                          </div>
                          <div class="right">
                            <span @click="deljb(index)"><img src="@/assets/images/r4.png" alt="">删除</span>
                            <span class="ai" @click="aishow=index"><img src="@/assets/images/r5.png" alt="">AI修改 
                            
                            </span>
                          </div>
                        </div>
                        <p class="tsipt" contenteditable="true" v-html="item.content"
                          @input="updateContent($event.target.innerText, index)">
                        </p>
                        </div>
                      </div>
                      <div class="item_r2">
                        <div class="p1 custom-scrollbar">创意，曾经需要等待打字机音效+低沉合成灵感降临..”</div>
                        <div class="to">去配音

                        </div>
                      </div>
                      <div class="item_r3">
                        <div class="p1 custom-scrollbar">打字机音效+低沉合成器音乐起</div>
                        <div class="to">去制作

                        </div>
                      </div>

                    </div>
                  </div>
                </transition-group>
                <div class="addjb" @click="addjb">+</div>
              </div>
              <div class="ctl">
                <div class="export">
                  <div class="title"><img src="@/assets/images/dc.png" alt=""> 文案导出</div>
                  <div class="options">
                    <div class="li">MarkDown文档</div>
                    <div class="li">wpsDown文档</div>
                    <div class="li">txtDown文档</div>
                  </div>

                </div>
                <div class="save" @click="save"><img src="@/assets/images/save.png" alt=""> 保存修改</div>
                <div class="createfj"><img src="@/assets/images/createfj.png" alt=""> 生成分镜</div>
              </div>
            </div>
          </div>
          <div class="r custom-scrollbar">
            <el-skeleton v-if="loading" :rows="4" animated />
            <div v-else>
              <div class="r1">角色/产品</div>
              <div class="r2 custom-scrollbar">

                <div class="line" v-for="(item, index) in characters" :key="index">
                  <div class="item">{{ item.name }} <span @click="deljs(index)"><img src="@/assets/images/r4.png"
                        alt=""></span></div>
                </div>
              </div>
              <div class="createjs" @click="createjs"><img src="@/assets/images/createfj.png" alt=""> 生成角色</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  data () {
    return {
      id: 0,
      step: 2,
      loading: true,
      idea_id: 0,
      segment_id: 0,
      part: [
      ],
      part2: [
      ],
      characters: [],
      title: '',
      // 拖拽
      dragThreshold: 100,
      draggingIndex: -1,
      startY: 0,
      zdrefresh:-1,
      aishow:-1
    }
  },
  async created () {
    this.id = this.$route.query.id
    if (this.$route.query.idea_id) {
      let res = await this.$http('api.getgmentation', {
        script_summary_id: this.$route.query.idea_id    //剧情梗概ID
      })
      if (res.data.script_segment == null) {
        let data = res.data.script_summary
        data.script_summary_id = data.id
        this.init(data)
        return
      }
      this.changeData(res)
    } else {
      this.init()
    }

  },
  mounted () {
    this.$bus.$emit('menu-active', false) // 关闭激活状态

  },
  methods: {
    async save(){
      let arr=[]
      const regex = /<span>(.*?)<\/span>/g;
      this.part2.forEach((item,index)=>{
        arr.push({
          id:index+1,
          title:item.title,
          duration:item.duration,
          content:item.content.replace(regex, '$1#')
        })
      })
      let res=await this.$http('api.udgmentation',{
        id:this.segment_id,
        segments:arr,
        characters:this.characters
      })
      if(res.code==1){
        this.$message.success('保存成功!')
      }
    },
    async aiChange(index){
      this.aishow=-1
      this.zdrefresh=index
      let res=await this.$http('api.changeGmentation',{
        content:this.part2[index].content,
        description:this.part2[index].aiChange+''
      })
      this.zdrefresh=-1
      if(res.code!=1)return
      let val=res.data.new_content.replace(/@([^#]+)#/g, '<span>@$1</span>')
      this.part2[index].content=val
      this.part[index].content=val
    },
    startDrag (index) {
      this.draggingIndex = index;  // 记录当前拖拽的索引
      // 记录初始Y坐标（兼容鼠标和触摸事件）
      const event = window.event;
      this.startY = event.type === 'mousedown' ? event.clientY : event.touches[0].clientY;

      // 绑定移动和结束事件（全局绑定，避免鼠标移出元素后失效）
      document.addEventListener('mousemove', this.handleDragMove);
      document.addEventListener('mouseup', this.endDrag);
      document.addEventListener('touchmove', this.handleDragMove);
      document.addEventListener('touchend', this.endDrag);
    },
    // 2. 拖拽中（移动鼠标/手指时触发）
    handleDragMove () {
      console.log(this.draggingIndex, '执行2');

      if (this.draggingIndex === -1) return;  // 未拖拽时直接返回

      // 获取当前Y坐标（兼容鼠标和触摸事件）
      const event = window.event;
      const currentY = event.type === 'mousemove' ? event.clientY : event.touches[0].clientY;

      // 计算移动距离（向上拖拽时，currentY < startY，距离为负数）
      const moveDistance = currentY - this.startY;

      // 条件：向上拖拽距离超过阈值 + 不是第一项（索引>0）
      console.log(moveDistance, this.dragThreshold, ';;');

      if (moveDistance < -this.dragThreshold && this.draggingIndex !== 0) {
        console.log('交换');

        let ls = JSON.parse(JSON.stringify(this.part[this.draggingIndex - 1]))
        this.part.splice(this.draggingIndex - 1, 1)
        this.part.splice(this.draggingIndex, 0, ls)

        let ls2 = JSON.parse(JSON.stringify(this.part2[this.draggingIndex - 1]))
        this.part2.splice(this.draggingIndex - 1, 1)
        this.part2.splice(this.draggingIndex, 0, ls2)
        // 更新拖拽索引（交换后，当前项位置上移，索引-1）
        this.draggingIndex--;
        // 重置初始Y坐标（避免连续交换）
        this.startY = currentY;
      } else if (moveDistance > this.dragThreshold && this.draggingIndex !== this.part.length - 1) {
        console.log('交换2');

        let ls = JSON.parse(JSON.stringify(this.part[this.draggingIndex]))
        this.part.splice(this.draggingIndex, 1)
        this.part.splice(this.draggingIndex + 1, 0, ls)

        let ls2 = JSON.parse(JSON.stringify(this.part2[this.draggingIndex]))
        this.part2.splice(this.draggingIndex, 1)
        this.part2.splice(this.draggingIndex + 1, 0, ls2)
        // 更新拖拽索引（交换后，当前项位置下移，索引+1）
        this.draggingIndex++;
        // 重置初始Y坐标（避免连续交换）
        this.startY = currentY;
      }
    },

    // 3. 结束拖拽（松开鼠标/手指时触发）
    endDrag () {
      console.log(this.part, '执行3');

      this.draggingIndex = -1;  // 重置拖拽状态
      // 移除全局事件监听（避免内存泄漏）
      document.removeEventListener('mousemove', this.handleDragMove);
      document.removeEventListener('mouseup', this.endDrag);
      document.removeEventListener('touchmove', this.handleDragMove);
      document.removeEventListener('touchend', this.endDrag);
    },
    // 换一批
    async refresh () {
      this.loading1 = true
      const res = await this.$http('api.refreshGenerate', { record_id: this.nowRecord_id })
      this.resetdata(res.data)
    },
    // 重新图片
    // recreate(){
    //   this.recreate(item,index)
    // },
    async resetdata (data) {
      this.loading1 = false
      this.allStep = 1
      data.ideas.forEach(item => {
        item.tags = item.tags.split(',')
      })
      this.nowRecord_id = data.record_id
      this.generateLits = data.ideas
      const res2 = await this.$http('api.getIdeas', { project_id: this.id })
      this.his = res2.data
    },
    async init (data) {
      this.idea_id = data.script_summary_id
      const res = await this.$http('api.segmentation', data)
      this.changeData(res)
    },
    changeData (res) {
      this.loading = false
      if (res.code != 1) {
        setTimeout(() => {
          this.$router.go(-1)
        }, 1000);
        return
      }
      this.title = res.data.script_summary.title
      this.segment_id = res.data.script_segment.id
      res.data.segments.forEach(item => {
        item.content = this.replaceSpecialText(item.content)
      })
      res.data.segments.aiChange=''
      this.part = res.data.segments
      this.part2 = JSON.parse(JSON.stringify(res.data.segments))
      this.characters = res.data.characters
    },
    addjb () {
      this.part.push({
        id: this.part.length + 1,
        duration: 5,
        content: '脚本内容',
        title: `Part ${this.part.length + 1}`
      })
      this.part2.push({
        id: this.part2.length + 1,
        duration: 5,
        content: '脚本内容',
        title: `Part ${this.part2.length + 1}`
      })
    },
    replaceSpecialText (text) {
      // 使用正则表达式匹配以@开头和#结尾的内容
      // 并替换为<span>标签包裹的内容
      return text.replace(/@([^#]+)#/g, '<span>@$1</span>')
    },
    // 编辑p标签
    updateContent (val, index) {
      console.log(val, index)
      this.part2[index].text = val
      console.log(this.part2[index].text, 'this.part[index].text')
    },
    // 删除脚本
    deljb (index) {
      this.part.splice(index, 1)
      this.part2.splice(index, 1)
    },
    // 删除角色
    deljs (index) {
      this.characters.splice(index, 1)
    },
    // 返回上一页
    repage () {
      this.$router.go(-1)
    },
    createjs () {
      sessionStorage.setItem('index4', JSON.stringify(this.characters))
      this.$router.push(`/project2/project2_4?id=${this.id}&summary_id=${this.segment_id}&random=${Math.random()}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.space {
  width: 100%;
  height: 100%;
  display: flex;

  .center {
    flex: 1;
    // padding: 20px;
    height: calc(100vh - 80px);

    .center-top {
      margin-top: 20px;
      height: 44px;
      position: relative;

      .return,
      .next {
        position: absolute;
        width: 134px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        top: 50%;
        transform: translateY(-50%);
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #DDDDDD;
        cursor: pointer;

        img {
          width: 20px;
          margin-right: 4px;
          transform: translateY(-2px);
        }
      }

      .return {
        left: 20px;
      }

      .next {
        right: 20px;
      }

      .step {
        margin: 0 auto;
        width: 620px;
        height: 44px;
        line-height: 44px;
        background: #FFFFFF;
        box-shadow: 2px 2px 12px 0px rgba(97, 92, 92, 0.2);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #046DFA;
        display: flex;
        justify-content: center;

        .item {
          font-size: 18px;
          color: #595959;
        }

        .itemed {
          font-weight: bold;
          color: #046DFA;
        }

        .jt {
          margin: 0 16px;

          img {
            width: 16px;
          }
        }
      }
    }

    .center-body {
      margin: 0 auto;
      width: 100%;
      margin-top: 20px;
      height: calc(100vh - 180px);
      overflow: hidden;

      .stepbox {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

      }


      .step3 {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        .l {
          width: 79%;
          height: 100%;
          background: #F8F8F8;
          border-radius: 16px 16px 16px 16px;
          // padding: 20px;
          padding-bottom: 20px;
          position: relative;
          overflow: auto;

          .l1 {
            // margin-top: 300px;
            width: 100%;
            text-align: center;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);

            .js {
              margin-top: 30px;
              font-size: 14px;
              color: #046DFA;
              width: 100%;
              text-align: center;
            }
          }

          .jb_top {
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid #b4b2b2;

            .jb_l {
              font-size: 22px;
              font-weight: 600;
              padding-left: 20px;
              color: #313131;
            }
          }

          .item_top {
            padding: 0 20px;
            padding-right: 26px;
          }

          .itembox {
            padding: 0 20px;
            height: 580px;
            overflow: auto;

            // background-color: pink;
            .addjb {
              width: 50%;
              height: 40px;
              line-height: 40px;
              font-size: 30px;
              margin: 0 auto;
              border: 1px solid #eee;
              background-color: #fff;
              border-radius: 0 0 4px 4px;
              border-top: 1px solid transparent;
              text-align: center;
              cursor: pointer;
            }
          }

          /* transition-group 生成的容器 */
          .drag-list-wrapper {
            position: relative;

            /* 确保列表项绝对定位时的参考容器 */
            .drag-handle {
              width: 24px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #999;
              cursor: grab;
              z-index: 2;
              /* 确保拖拽图标在最上层 */
            }

            .drag-handle:active {
              cursor: grabbing;
            }

            /* 禁止文本选中 */
            .drag-list-item,
            .drag-handle {
              user-select: none;
              -moz-user-select: none;
              -webkit-user-select: none;
              -ms-user-select: none;
            }

            /* ################################ 过渡动画核心样式 ################################ */
            /* 进入（新增/移动到目标位置）时的初始状态 */
            .list-swap-enter {
              opacity: 0;
              transform: translateY(20px);
              /* 从下方滑入 */
            }

            /* 进入过程中的动画 */
            .list-swap-enter-active {
              opacity: 1;
              transform: translateY(0);
              transition: opacity 0.3s ease, transform 0.3s ease;
              /* 动画时长和缓动函数 */
            }

            /* 离开（删除/移动出原位置）时的初始状态 */
            .list-swap-leave {
              opacity: 1;
              transform: translateY(0);
            }

            /* 离开过程中的动画 */
            .list-swap-leave-active {
              opacity: 0;
              transform: translateY(-20px);
              /* 向上滑出 */
              transition: opacity 0.3s ease, transform 0.3s ease;
            }

            /* 关键：处理列表项移动时的过渡（Vue2需手动添加这个类） */
            .list-swap-move {
              transition: transform 0.3s ease;
              /* 位置移动的平滑过渡 */
            }

            /* 修复 transition-group 动画结束后残留的样式问题 */
            .list-swap-enter-to,
            .list-swap-leave-to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .item {
            width: 100%;
            // padding-bottom: 20px;
            // border-bottom: 1px solid #b4b2b2;
            display: flex;
            position: relative;
            z-index: 1;

            .item_left {
              width: 100px;
              position: relative;

              .line {
                width: 1px;
                height: 100%;
                margin-left: 20px;
                background-color: #dfdddd;
              }

              .part {
                position: absolute;
                top: 20px;
                left: 40px;
                width: 50px;
                height: 20px;
                line-height: 20px;
                border-radius: 8px;
                text-align: center;
                font-size: 14px;
                color: #FFFFFF;
                background-color: #267beb;
                z-index: 2;
              }

              .part::after {
                position: absolute;
                top: 5px;
                left: -24px;
                border: 2px solid #267beb;
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-radius: 50%;
                display: block;
                content: '';
              }

              .part::before {
                position: absolute;
                top: 9px;
                left: -16px;
                width: 16px;
                height: 2px;
                background-color: #267beb;
                border-radius: 50%;
                display: block;
                content: '';
              }

              .duration {
                font-size: 13px;
                position: absolute;
                top: 20px;
                left: -10px;
                width: 30px;
                line-height: 20px;
                height: 20px;

                // background-color: pink;
                input {
                  display: none;
                  text-align: center;
                  width: 30px;
                  border: 1px solid transparent;
                  // background-color: skyblue;
                  border: 1px solid #046CF3;
                  border-radius: 4px;
                }
              }

              .duration:hover input {
                display: block;
              }

              .duration:hover span {
                display: none;
              }

              .td {
                position: absolute;
                bottom: 0;
                left: 40px;
                font-size: 14px;
                // cursor: move;
                // 防止字体蓝色拖拽
                user-select: none;
                -moz-user-select: none;
                -webkit-user-select: none;
                -ms-user-select: none;

                img {
                  width: 26px;
                  transform: translateY(-1px);
                  -webkit-user-drag: none;
                  user-drag: none;
                }
              }
            }

            .item_right {
              flex: 1;
              display: flex;
              border-left: 1px solid #eee;

              // border-top: 1px solid #eee;
              >div {
                border-right: 1px solid #eee;
                border-bottom: 1px solid #eee;
                background-color: #fff;
                padding: 10px;
              }

              .item_r1 {
                width: 66%;

                .it1 {
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                  position: relative;
                  .aiChange{
                        position: absolute;
                        bottom: -150px;
                        width: 300px;
                        height: 150px;
                        right: 0;
                        border: 1px solid #1b5ff1;
                        border-radius: 4px;
                        overflow: hidden;
                        background-color: #fff;
                        span{
                          position: absolute;
                          left: 0px;
                          top: 0px;
                          height: 30px;
                          line-height: 38px;
                          color: #1b5ff1;
                          font-size: 14px;
                          background-color: #ffffff;
                          padding: 0 4px;
                          img{
                            width: 16px;
                          }
                        }
                        textarea{
                          padding: 10px;
                          font-size: 14px;
                          width: 100%;
                          height: 120px;
                          border: none;
                          
                          text-indent: 5em;
                          overflow: auto;
                          resize: none;
                        }
                        i{
                          cursor: pointer;
                          float: right;
                          display: block;
                          // width: 40px;
                          margin-right: 10px;
                          height: 20px;
                          font-size: 24px;
                          font-weight: 600;
                          line-height: 10px;
                          // background-color: pink;
                        }
                      }
                  .left {
                    width: 60%;
                    color: #262626;
                    display: flex;
                    line-height: 40px;

                    span {
                      line-height: 40px;
                      font-size: 20px;
                      margin-right: 10px;
                    }

                    input {
                      padding: 0 10px;
                      border: 1px solid transparent;
                      flex: 1;
                      height: 40px;
                      font-size: 20px;
                      background-color: transparent;
                      border-radius: 4px;
                    }

                    input:hover {
                      border: 1px solid #3c6fcf;
                    }
                  }

                  .right {
                    display: none;
                    margin-top: 10px;
                    span {
                      cursor: pointer;
                      font-size: 16px;
                      color: #595959;
                      margin-right: 20px;

                      img {
                        width: 20px;
                        margin-right: 2px;
                        transform: translateY(-2px);
                      }
                    }
                    .ai{
                      
                      
                    }
                  }
                }

                .tsipt {
                  outline: none;
                  // margin-top: 20px;
                  padding: 10px;
                  width: 100%;
                  height: auto;
                  border-radius: 4px;
                  resize: none;
                  border: 1px solid transparent;
                  background-color: transparent;
                  margin-bottom: 0;
                }

                .tsipt:hover {
                  border: 1px solid #407cd4;
                }
              }

              .item_r1:hover .it1 .right {
                display: block;
              }

              .item_r2,
              .item_r3 {
                width: 17%;

                .p1 {
                  height: 140px;
                  font-size: 14px;
                  overflow: auto;
                }

                .to {
                  float: right;
                  margin-top: 10px;
                  width: 80px;
                  color: #267beb;
                  text-align: center;
                }
              }

            }

          }

          .item:last-child {
            border-bottom: none;
            margin-bottom: 0;
          }

          .ctl {
            width: 100%;
            height: 30px;
            margin-top: 6px;
            position: relative;
            z-index: 100;
            .export {
              cursor: pointer;
              float: left;
              margin-left: 20px;
              height: 30px;
              width: 120px;
              background-color: #fff;
              line-height: 30px;
              text-align: center;
              position: relative;
              
              >div {
                font-size: 14px;

                img {
                  width: 20px;
                }
              }
              .options{
                display: none;
                position: absolute;
                width: 100%;
                top: -90px;
                background-color: #fff;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #eee;
                .li{
                  font-size: 14px;
                  width: 100%;
                  height: 30px;
                  line-height: 30px;
                  border-bottom: 1px solid #eee;
                }
                .li:hover{
                  background-color: #f3f3f3;
                }
                .li:last-child{
                  border-bottom: none;
                }
              }

            }
            .export:hover .options{
              display: block;
            }

            .save {
              cursor: pointer;
              float: left;
              margin-top: 6px;
              margin-left: 40px;
              font-size: 14px;

              img {
                width: 20px;
              }
            }

            .createfj {
              cursor: pointer;
              height: 30px;
              line-height: 30px;
              padding: 0 10px;
              color: white;
              background-color: #1e65e9;
              float: right;
              margin-right: 20px;
              font-size: 14px;
              border-radius: 4px;

              img {
                width: 18px;
              }
            }
          }


        }

        .r {
          padding: 20px;
          width: 19%;
          height: 100%;
          background: #F8F8F8;
          border-radius: 16px 16px 16px 16px;
          overflow: auto;

          .r1 {
            font-size: 24px;
            color: #262626;
          }

          .r2 {
            margin-top: 10px;
            padding-bottom: 20px;
            height: 600px;
            overflow: auto;

            .line {
              margin-top: 20px;
              width: 100%;
              display: flex;
              justify-content: space-between;

              .item {
                display: flex;
                width: 90%;
                padding: 10px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #DDDDDD;
                justify-content: space-between;

                span {
                  cursor: pointer;

                  img {
                    width: 20px;
                  }
                }
              }

              .item:hover {
                border: 1px solid #3b81eb;
              }

              .del {
                height: 30px;
                font-size: 30px;
                color: #fa7a7a;
                cursor: pointer;
              }

              .del:hover {
                color: #f72b2b;
              }
            }

          }
          .createjs {
              cursor: pointer;
              height: 30px;
              margin-top: 20px;
              line-height: 30px;
              padding: 0 10px;
              color: white;
              background-color: #1e65e9;
              float: right;
              margin-right: 10px;
              font-size: 14px;
              border-radius: 4px;

              img {
                width: 18px;
              }
            }

        }

      }
    }
  }
}
</style>
